var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      ref: "modal",
      attrs: {
        title: "Add to Email Flow ",
        subheading: _vm.$t(_vm.modalSubheading),
        "aria-labelledby": "AudienceAddToEmailFlowModal",
        overflow: true,
        loading: _vm.loading,
        action: "Add to Email Flow",
        "secondary-action": "Never Mind"
      },
      on: { cta: _vm.submitModalForm, "secondary-cta": _vm.hide }
    },
    [
      _c("Transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _vm.loading
          ? _c(
              "div",
              { key: "loading" },
              [
                _c(
                  "div",
                  { staticClass: "importing-animation" },
                  [
                    _c("InlineSvg", {
                      attrs: { src: "/images/icons/ic-customer.svg" }
                    }),
                    _vm._v(" "),
                    _c("InlineSvg", {
                      attrs: { src: "/images/icons/ic-customer.svg" }
                    }),
                    _vm._v(" "),
                    _c("InlineSvg", {
                      attrs: { src: "/images/icons/ic-customer.svg" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("AppProgress", {
                  attrs: {
                    min: 0,
                    max: _vm.totalCustomers,
                    value: _vm.processedCount
                  }
                })
              ],
              1
            )
          : _c("div", { key: "content" }, [
              _c("form", { attrs: { id: "audience_bulk_tagging_form" } }, [
                _c("div", { staticClass: "overflow-visible" }, [
                  _c(
                    "div",
                    { staticClass: "overflow-visible border" },
                    [
                      _c("AppDropdown", {
                        staticClass: "email-flow-dropdown",
                        attrs: {
                          value: _vm.selectedFlow,
                          options: _vm.flowsList,
                          searchable: false,
                          placeholder: "Select an email flow",
                          "image-width": "23px",
                          "right-align": false,
                          "display-label": "name",
                          label: "name",
                          AppDropdown: true,
                          small: false,
                          "rounded-icons": true
                        },
                        on: { select: _vm.selectFlow }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.formErrors &&
                            _vm.formErrors.emailFlowSelectionErrors,
                          expression:
                            "formErrors && formErrors.emailFlowSelectionErrors"
                        }
                      ],
                      staticClass: "para-3 text-danger mb-2"
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.formErrors.emailFlowSelectionErrors) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  )
                ])
              ])
            ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }